module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Sports/golf-1cbdd60ec809b37cdcd403d2f6a67b6c.svg";